import api from '../baseAPIs/core';
import type { StoreType } from '@extTypes/api/customily/user';
import type { AddStoreResult } from './typings';

export const addStore = async (url: string, type: StoreType): Promise<AddStoreResult> =>
    api.post('Users/Stores', { Type: type, Url: url }).then(({ data }) => data);
